import { render, staticRenderFns } from "./BLCallPop.vue?vue&type=template&id=7b386dea"
import script from "./BLCallPop.vue?vue&type=script&lang=js"
export * from "./BLCallPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b386dea')) {
      api.createRecord('7b386dea', component.options)
    } else {
      api.reload('7b386dea', component.options)
    }
    module.hot.accept("./BLCallPop.vue?vue&type=template&id=7b386dea", function () {
      api.rerender('7b386dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLCallPop.vue"
export default component.exports